import { useLingui } from "@lingui/react/macro";
import { AccessibleIcon } from "@offstreetparking/design-system/accessibility";
import { ExternalLinkIcon } from "@offstreetparking/design-system/icons/ExternalLinkIcon";
import { MapIcon } from "@offstreetparking/design-system/icons/MapIcon";
import { Heading } from "@offstreetparking/design-system/typography";
import { Text } from "@offstreetparking/design-system/typography";
import { classNames } from "@offstreetparking/design-system/utils";
import { BrandingBanner } from "../BrandingBanner";
import { ViewMap, type ViewMapProps } from "../dataDisplay/ViewMap";
export type PermitTypeHeaderProps = {
	name: string;
	brandingUrl?: string;
	venue?: ViewMapProps["place"] & {
		name?: string;
	};
};
export const PermitTypeHeader = ({ name, brandingUrl, venue }: PermitTypeHeaderProps) => {
	const { t } = useLingui();
	return (
		<>
			{brandingUrl && <BrandingBanner brandingUrl={brandingUrl} />}

			<div
				className={classNames(
					"flex flex-col items-center justify-center bg-neutral px-4 py-2",
					!brandingUrl ? "lg:rounded-t-lg" : "",
				)}
			>
				<Heading As="h2" kind="h3" className="text-center text-white">
					{name}
				</Heading>

				{venue?.name && (
					<div className="flex items-center gap-2">
						<Text className="text-white" size="sm">
							{venue.name}
						</Text>
						<ViewMap place={venue} aria-label={`${t`Directions`} ${t`(opens in a new tab)`}`}>
							<div className="flex items-center">
								<AccessibleIcon>
									<MapIcon className="mr-1 h-4 w-4 text-white" />
								</AccessibleIcon>
								<Text className="text-white underline" size="sm" aria-hidden="true">
									{t`Directions`}
								</Text>

								<span>
									<AccessibleIcon>
										<ExternalLinkIcon className="ml-0.5 inline h-3 w-3 text-white" />
									</AccessibleIcon>
								</span>
							</div>
						</ViewMap>
					</div>
				)}
			</div>
		</>
	);
};
